import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from '../constants';
import { QUERY_TIMEOUT_MS } from '../hooks';

export const reportTimeMetric = ({
    metricName,
    time,
    timeout = QUERY_TIMEOUT_MS,
}: {
    metricName: string;
    time: number;
    timeout?: number;
}) => {
    stats.time(METRICS_PREFIX, `${metricName}${time > timeout ? '.outlier' : ''}`, time);
};
